import { call, put, takeLatest } from "redux-saga/effects";

import { CREATE_PRE_PAYMENT } from "./types";
import { createPrePaymentSuccess, setLoading } from "./actions";
import PrepaymentApiService from "../../services/prepaymentApiService";
import { requestDataAdapter } from "./helpers";
import { showModal, hideModal } from "../modal/actions";
import modalNames from "../../constants/modalNames";
import { goToPaymentGateway } from "../invoice/actions";

function* createPrePaymentAsync(action) {
  try {
    yield put(setLoading(true));
    const requestData = requestDataAdapter(action.payload);
    const response = yield call(() => PrepaymentApiService.createPrepayment(requestData));
    if (response.hasError) {
      yield put(hideModal(modalNames.PRE_PAYMENT_MODAL));
      yield put(showModal(modalNames.ERROR_MODAL, { errors: response.errors }));
    } else {
      yield put(createPrePaymentSuccess(response.payload));
      yield put(
        goToPaymentGateway({
          currency: response.payload.currency,
          amount: action.payload,
          code: response.payload.invoiceId
        })
      );
    }
  } catch (err) {
    yield put(hideModal(modalNames.PRE_PAYMENT_MODAL));
    yield put(showModal(modalNames.ERROR_MODAL, { errors: ["SERVER_ERROR"] }));
  } finally {
    yield put(setLoading(false));
  }
}

function* watchCreatePrePaymentAsync() {
  yield takeLatest(CREATE_PRE_PAYMENT, createPrePaymentAsync);
}

export { watchCreatePrePaymentAsync };
